import app from "./appReducer";
import authPoll from "./authPollReducer";
import auth from "./authReducer";
import categories from "./categoriesReducer";
import events from "./eventReducer";
import interactive from "./interactiveReducer";
import myVideo from "./myVideoReducer";
import posts from "./pollReducer";
import video from "./videoReducer";

export {
  app,
  auth,
  authPoll,
  categories,
  events,
  interactive,
  myVideo,
  posts,
  video,
};
